export type ExecutionKind = 'order' | 'optionOrder' | 'oda' | 'exchange';

export type ExecutionIntent =
  | { kind: 'idle'; activation: number }
  | {
      kind: Exclude<ExecutionKind, 'exchange'>;
      instrumentId: number;
      activation: number;
    }
  | { kind: 'exchange'; activation: number };

export const idleExecution = (activation = 0): ExecutionIntent => ({
  kind: 'idle',
  activation,
});

export const activateExecution = (
  current: ExecutionIntent,
  kind: ExecutionKind,
  instrumentId?: number,
): ExecutionIntent => {
  const sameIntent =
    current.kind === kind &&
    (kind === 'exchange' ||
      ('instrumentId' in current && current.instrumentId === instrumentId));

  if (sameIntent) return current;

  const activation = current.activation + 1;
  return kind === 'exchange'
    ? { kind, activation }
    : { kind, instrumentId: instrumentId as number, activation };
};

export const executionIntentKey = (intent: ExecutionIntent) =>
  intent.kind === 'idle'
    ? `idle:${intent.activation}`
    : intent.kind === 'exchange'
      ? `exchange:${intent.activation}`
      : `${intent.kind}:${intent.instrumentId}:${intent.activation}`;

export const executionTargetsInstrument = (
  intent: ExecutionIntent,
  instrumentId: number,
) => 'instrumentId' in intent && intent.instrumentId === instrumentId;
